export default function clamp(n, min, max) {
  return Math.min(Math.max(n, min), max);
}
